export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(amount);
}

export function formatCompactCurrency(amount: number): string {
  const absolute = Math.abs(amount);
  if (absolute >= 1000000000) {
    return `$${(amount / 1000000000).toFixed(1)}B`;
  }
  if (absolute >= 1000000) {
    return `$${(amount / 1000000).toFixed(1)}M`;
  }
  if (absolute >= 1000) {
    return `$${(amount / 1000).toFixed(0)}K`;
  }
  return formatCurrency(amount);
}

export function formatPercent(value: number | null, includeSign = true): string {
  if (value === null || !Number.isFinite(value)) {
    return 'n/a';
  }
  const sign = includeSign && value > 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
}

export function formatDateKey(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return value;
  }
  return `${match[2]}/${match[3]}/${match[1]}`;
}

export function formatDateRange(from: string, to: string): string {
  return `${formatDateKey(from)} – ${formatDateKey(to)}`;
}
